import React from "react";
import { NavLink } from "react-router-dom";
import { myTWHeading } from "./heading/myTW";
import { oneProfileHeading } from "./heading/oneProfile";
import useMobile from "../../hooks/useMobile";

export default function NavHeading() {
  let heading;
  if (isNewDomain()) {
    heading = myTWHeading();
  } else {
    heading = oneProfileHeading();
  }
  const { isMobile } = useMobile();

  return (
    <NavLink
      to={"/profile"}
      style={{
        textDecoration: "none",
        margin: isMobile ? "24px 0 24px 14px" : "56px auto 32px",
      }}
      data-testid={"nav-heading"}
    >
      {heading}
    </NavLink>
  );
}

function isNewDomain() {
  return window.location.host.endsWith("my.thoughtworks.net");
}
